import { addMethod, string } from 'yup';

import { isValidPhoneNumber } from './phonenumber';
import { isValidCompanyNumber, isValidVatNumber } from './vat-number';

declare module 'yup' {
  interface StringSchema {
    phone(): StringSchema;
    vatNumber(): StringSchema;
    companyNumber(): StringSchema;
  }
}

function getCountryKeyFromParent(parent: { country?: { key?: string } | null } | undefined): string | undefined {
  return parent?.country?.key;
}

addMethod(string, 'phone', function () {
  return this.test('phone', 'ongeldig telefoonnummer', (val) => (val ? isValidPhoneNumber(val) : true));
});

addMethod(string, 'vatNumber', function () {
  return this.test('vatNumber', 'ongeldig btw nummer', function (val) {
    if (!val) {
      return true;
    }
    return isValidVatNumber(val, getCountryKeyFromParent(this.parent));
  });
});

addMethod(string, 'companyNumber', function () {
  return this.test('companyNumber', 'ongeldig ondernemingsnummer', function (val) {
    if (!val) {
      return true;
    }
    return isValidCompanyNumber(val, getCountryKeyFromParent(this.parent));
  });
});
